import styles from './About.module.css';
import CallToAction from '../../generic/call-to-action/CallToAction.tsx';
import PersonCard from "../person-card/PersonCard.tsx";

export default function About() {
  return (
    <div className="container">

      <main>

        {/* ── Hero ── */}
        <section className={styles.hero}>
          <div className={styles.heroInner}>
            <span className={styles.heroEyebrow}>Our mission</span>
            <h1 className={styles.heroHeading}>
              We built the e-learning platform
              <em> we wished existed.</em>
            </h1>
            <div className={styles.heroRule} />
            <p className={styles.heroLead}>
              Code Venture Labs is an e-learning platform built by engineers, for engineers.
              We don't believe in passive video-watching or quiz-farming. Every lesson
              is designed around a single question: <strong>does this make you a better developer?</strong>
            </p>
          </div>
        </section>

        {/* ── Values ── */}
        <section className={styles.values}>
          <div className={styles.valuesInner}>
            <div className={styles.valueCard}>
              <span className={styles.valueIcon}>
              <i className={`fas fa-bolt ${styles.valueIcon}`} />
              </span>
              <h3 className={styles.valueTitle}>Practical first</h3>
              <p className={styles.valueText}>
                Every concept is taught through real code you'd write on the job, not toy examples that fall apart the moment you leave the lesson.
              </p>
            </div>
            <div className={styles.valueCard}>
              <span className={styles.valueIcon}>
                <i className={`fas fa-compass ${styles.valueIcon}`} />
              </span>
              <h3 className={styles.valueTitle}>Opinionated paths</h3>
              <p className={styles.valueText}>
                We curate the curriculum so you don't have to. No decision fatigue, just a clear path from where you are to where you want to be.
              </p>
            </div>
            <div className={styles.valueCard}>
              <span className={styles.valueIcon}>
                <i className={`fas fa-rotate ${styles.valueIcon}`} />
              </span>
              <h3 className={styles.valueTitle}>Built for retention</h3>
              <p className={styles.valueText}>
                Spaced repetition, knowledge checks, and project-based milestones mean you actually remember what you learn three months later.
              </p>
            </div>
          </div>
        </section>

        {/* ── Story ── */}
        <section className={styles.story}>
          <div className={styles.storyInner}>
            <div className={styles.storyText}>
              <span className={styles.storyEyebrow}>The story</span>
              <h2 className={styles.storyHeading}>Started from frustration</h2>
              <p className={styles.storyBody}>
                While recoverinhg from an arm fracture, I filled my days with taking web development courses.
                After having finished these courses, I often felt I still couldn't build anything. The content
                wasn't the problem. The structure was.
              </p>
              <p className={styles.storyBody}>
                Code Venture Labs launched in 2025 with a single course and 50 beta users. Today
                we have over 11,000 learners across 31 countries, a curriculum spanning
                frontend, backend, algorithms, testing and a waitlist for our upcoming
                mentorship programme.
              </p>
              <div className={styles.stats}>
                <div className={styles.stat}>
                  <span className={styles.statNum}>11k+</span>
                  <span className={styles.statLabel}>Learners</span>
                </div>
                <div className={styles.statDivider} />
                <div className={styles.stat}>
                  <span className={styles.statNum}>31</span>
                  <span className={styles.statLabel}>Countries</span>
                </div>
                <div className={styles.statDivider} />
                <div className={styles.stat}>
                  <span className={styles.statNum}>84%</span>
                  <span className={styles.statLabel}>Completion rate</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <CallToAction heading="Ready to start building?"
                      text="Join 11,000 developers who are learning the right way." />

      </main>

    </div>
  );
}
